import { Message, useAgent } from '@copilotkitnext/react';
import { useEffect } from 'react';

export const useSaveRestoreMessages = (messageKey?: string) => {
  const { agent } = useAgent();
  const messages = agent?.messages;

  // Save Chat Messages
  useEffect(() => {
    if (!messageKey || messages.length === 0) {
      return;
    }

    const chatMessages = JSON.stringify(messages);
    localStorage.setItem(`messages-${messageKey}`, chatMessages);
  }, [messageKey, messages]);

  // Restore Chat Messages
  useEffect(() => {
    if (!messageKey) {
      return;
    }

    const chatMessages = localStorage.getItem(`messages-${messageKey}`) || '[]';
    const chatMessagesJson = JSON.parse(chatMessages) as Message[];

    agent?.setMessages(chatMessagesJson);

    return () => {
      agent?.setMessages([]);
    };
  }, [messageKey, agent.threadId]);
};
